
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { faRotateRight } from '@fortawesome/free-solid-svg-icons';
import { Button, Date } from '@micromag/core/components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { mediaJob } from '../../lib/PropTypes';

import styles from '../../../styles/items/media-job.module.scss';

const propTypes = {
    job: mediaJob,
    onRestartClicked: PropTypes.func,
};

const defaultProps = {
    job: null,
    onRestartClicked: null,
};

const MediaJobItem = ({ job, onRestartClicked }) => {
    const getBadgeForPipelineState = (pipelineState) => {
        switch (pipelineState) {
            case 'started':
                return <span className={classNames('badge', 'text-bg-primary')}>
                    <FormattedMessage defaultMessage='En cours' description='MediaJobsList - job state value' />
                </span>;

            case 'ended':
                return <span className={classNames('badge', 'text-bg-success')}>
                    <FormattedMessage defaultMessage='Terminé' description='MediaJobsList - job state value' />
                </span>;

            case 'failed':
                return <span className={classNames('badge', 'text-bg-warning')}>
                    <FormattedMessage defaultMessage='Échec' description='MediaJobsList - job state value' />
                </span>;

            default:
                return <span className={classNames('badge', 'text-bg-secondary')}>
                    {pipelineState};
                </span>;
        }
    }

    return (
        <li key={job.id} className={classNames('list-group-item', styles.container)}>
            <div className={classNames('d-flex', 'flex-row', 'gap-2', 'align-items-center')}>
                <div className={classNames('text-body', styles.dimText)}>
                    <Date date={job.created_on} withTime />
                </div>
                <div className='flex-grow-1'>
                    {job.display_name || job.pipeline_name}
                </div>

                {job.state !== 'started' ? (
                    <Button
                        className='px-2 py-0 btn-primary'
                        icon={<FontAwesomeIcon icon={faRotateRight} />}
                        onClick={onRestartClicked ? () => onRestartClicked(job.id) : null}
                        disabled={!onRestartClicked}
                    />
                ) : null}
                {getBadgeForPipelineState(job.state)}
            </div>
        </li>
    );
}

MediaJobItem.propTypes = propTypes;
MediaJobItem.defaultProps = defaultProps;

export default MediaJobItem;
